export default "__VITE_ASSET__79e4e5af__"